export enum CookiesEnum {
    GBUUID = "gbuuid",
    USER_TRACKING_TOKEN = "rm_user_token",
    USER_SOURCE = "rm_source",
    USER_GCLID = "rm_gclid",
    USER_UTM_SOURCE = "rm_utm_source",
    USER_UTM_CAMPAIGN = "rm_utm_campaign",
    USER_UTM_MEDIUM = "rm_utm_medium",
    USER_FBCLID = "rm_fbclid",
    USER_MSCLKID = "rm_msclkid",
    USER_TTCLID = "rm_ttclid",
    USER_CLICK_ID = "rm_click_id",
    // New individual tracking cookies
    USER_REFERER = "rm_user_referer",
    USER_ENTRY_PAGE = "rm_user_entry_page",
}
